import { useDataValue } from 'Simple/Data.js'
import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let tabSorting = useDataValue({
    context: 'tab',
    path: 'selected.sorting',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    let persisted = tabSorting?.[props.stageId]
    if (persisted && Object.values(persisted).some(v => v !== null)) {
      return { ...data, selected: persisted }
    }
    return data
  }, [props.stageId]) // eslint-disable-line react-hooks/exhaustive-deps
}
